import React, { useEffect, useState } from 'react';

import { GraphQLErrorResponse } from '@components/pages/commonType';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Card, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';

import { getAreaInfoApi } from '@apis/index';
import { AreaInfoDialogInput, AreaInfoDialogState, MessageDialogState } from '@atom/DialogState';

import { GetAreaInfoQueryVariables } from '../../../API';

const images = {
  maxHeight: '100%',
  maxWidth: '100%',
  height: 'auto',
  width: 'auto',
  'align-items': 'center',
  display: 'flex',
  justifyContent: 'center'
};

const AreaInfoDialog = () => {
  /* 共通State */
  const setMessageDialogState = useSetRecoilState(MessageDialogState);
  const resetAreaInfoDialogState = useResetRecoilState(AreaInfoDialogState);

  const areaInfoDialogState: AreaInfoDialogInput = useRecoilValue(AreaInfoDialogState);

  const [areaInfo, setAreaInfo] = useState<any>('');

  const { areaInfoData, onConfirmClick } = areaInfoDialogState;

  const { facilityId, areaId } = areaInfoData;

  const handleClose = () => {
    resetAreaInfoDialogState();
  };

  // エリア情報取得
  const getData = async (facility: string, area: string) => {
    try {
      const input: GetAreaInfoQueryVariables = {
        input: {
          facilityId: facility,
          areaId: area
        }
      };

      // データ取得
      const result = await getAreaInfoApi(input);
      setAreaInfo(result);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);

      let message = '時間をおいてから再度お試しください。解決できない場合は管理者へお問い合わせください。';
      if ('errors' in (error as GraphQLErrorResponse) && (error as GraphQLErrorResponse).errors.length !== 0) {
        message = (error as GraphQLErrorResponse).errors[0].message;
      }
      setMessageDialogState({
        open: true,
        messageData: {
          title: 'エラーが発生しました。',
          message
        }
      });
    }
  };

  useEffect(() => {
    // facilityId と areaId が有効な場合にのみ API を呼び出す
    if (facilityId && areaId) {
      getData(facilityId, areaId);
    }
  }, [facilityId, areaId]);

  // 改行コードを置換する
  const replaceNewLine = (text?: string) => {
    if (!text) return undefined;
    const texts = text.split('\\n').map((item, index) => (
      <>
        {item}
        <br />
      </>
    ));

    return (
      <Typography variant="body1" component="p" textAlign="left">
        {texts}
      </Typography>
    );
  };

  return (
    <Dialog open={areaInfoDialogState.open} onClose={handleClose}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="area-dialog-title">
        <Typography variant="h5" gutterBottom>
          {areaInfo.areaName}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card style={{ padding: 16, ...images }} elevation={0}>
              <img src={`/images/${facilityId}/area/${areaInfo.areaImagePath}`} alt="areaImages" style={images} />
            </Card>
            {areaInfo.sectionImagePath ? (
              <Card style={{ padding: 16, ...images }} elevation={0}>
                <img
                  src={`/images/${facilityId}/section/${areaInfo.sectionImagePath}`}
                  alt="sectionImages"
                  style={images}
                />
              </Card>
            ) : (
              ''
            )}
          </Grid>

          <Grid item xs={12}>
            <Typography textAlign="left">{replaceNewLine(areaInfo.explanation)}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography textAlign="right">(1時間あたり/税込) {areaInfo.minFee}円 〜</Typography>
          </Grid>
          {/* エリア一覧画面からの表示がなくなったため削除 */}
          {/* 
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              style={{
                backgroundColor: '#02ada9',
                color: 'white',
                borderRadius: '6px',
                fontSize: '1em'
              }}
              onClick={() => {
                onConfirmClick();
              }}
            >
              このエリアの空き状況を確認
            </Button>
          </Grid> */}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AreaInfoDialog;
